export const CLIENTS = {
  ADLER: "adler",
  PERFORM_STATS: "womansworldcup_live",
  TRANSFERMARKT: "transfermarkt_live",
  SHOWCASE: "showcase_live",
};
